const getEnumValues = (options: { value: string; label?: string }[]) => {
  return options?.map(({ value }) => value);
};

export default getEnumValues;
